module.exports = __webpack_public_path__ + "img/ic_pdf.774e4296.svg";